import * as allChains from 'wagmi/chains';

export type Chain = allChains.Chain;

/**
 * List of all EVM chains supported by the app.
 * @see https://wagmi.sh/react/api/chains
 */
export const chains: Chain[] = Object.values(allChains);

/**
 * Gets the chain object for the given chain id.
 * @param chainId - Chain id of the target EVM chain.
 * @returns Viem's chain object.
 */
export function getChain(chainId: number) {
  for (const chain of chains) {
    if (chain.id === chainId) {
      return chain;
    }
  }
}
